const ACTIONS = {
    SET_USER: 'set_user',
    SET_APPLICATION: 'set_application',
    SET_APPLICATION_META: 'set_application_meta',
    UPDATE_APPLICATION: 'update_application',
};

function persist(state) {
    sessionStorage.setItem('applicationCache', JSON.stringify(state));
}

export function hydrate() {
    return JSON.parse(sessionStorage.getItem('applicationCache'));
}

export function reducer(state, action) {
    let newState;
    switch(action.type) {
        case ACTIONS['SET_USER']:
            newState = {
                ...state,
                userMeta: {
                    ...action.payload,
                },
            };
            persist(newState);
            return newState;
        case ACTIONS['SET_APPLICATION']:
            newState = {
                ...state,
                application: {
                    ...action.payload,
                },
            };
            persist(newState);
            return newState;
        case ACTIONS['SET_APPLICATION_META']:
            newState = {
                ...state,
                applicationMeta: {
                    ...state.applicationMeta,
                    ...action.payload,
                },
            }
            persist(newState);
            return newState;
        case ACTIONS['UPDATE_APPLICATION']:
            newState = {
                ...state,
                application: {
                    ...state.application,
                    ...action.payload,
                },
            };
            persist(newState);
            return newState;
        default:
            return state;
    }
}
export {
    ACTIONS,
};
